import React from "react";
import "./Customization_Offcanvas.css";
import { Form, Offcanvas } from "react-bootstrap";
import IncrementDecrementBtn from "../../../common_components/common_btn/Increment_Decrement_Btn/IncrementDecrementBtn";
import Blue_Btn from "../../../common_components/common_btn/Blue_Btn/Blue_Btn";

const Customization_Offcanvas = ({ show, onHide, addToCartFunc, ...props }) => {
  return (
    <Offcanvas
      show={show}
      onHide={onHide}
      className="sort_offcanvas Customization_Offcanvas"
      placement="end"
    >
      <Offcanvas.Header>
        <div className="logo_div">
          <img
            src={process.env.PUBLIC_URL + "/assets/images/logo/logo.png"}
            className="logo"
          />
        </div>
        <div className="close_div" onClick={onHide}>
          <img
            src="/assets/images/icons/close_white.png"
            className="close_img"
          />
        </div>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="inner_div">
          <p className="section_title">Mattress Customisation</p>

          <Form className="form-holder">
            <div className="row">
              <div className="col-lg-6">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Length In Inches</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Enter Length"
                  />
                </Form.Group>
              </div>
              <div className="col-lg-6">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Breadth In Inches</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Enter Breadth"
                  />
                </Form.Group>
              </div>
              <div className="col-lg-6">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Thickness In Inches</Form.Label>
                  <Form.Control
                    type="text"
                    name="email"
                    placeholder="Enter Thickness"
                  />
                </Form.Group>
              </div>
              <div className="col-lg-6">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Quantity</Form.Label>
                  <IncrementDecrementBtn />
                </Form.Group>
              </div>
            </div>
          </Form>
        </div>
        <div className="btn_holder">
          <Blue_Btn btnText={"ADD TO CART"} onClick={addToCartFunc} />
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default Customization_Offcanvas;
